module.exports = __webpack_public_path__ + "static/img/14000054.18f6b9ee.png";